import "imagesloaded";
import "jquery-ui-slider-pips-npm";
import LazyLoad from "vanilla-lazyload";

const $ = jQuery.noConflict();

export default class Portfolio {
  $el: JQuery<HTMLElement> = $(".off-portfolio-archive");
  pageLazyLoad: any;
  color: string;
  mistery: number;

  constructor() {
    if (!this.$el.length) return;

    const options: ImagesLoaded.ImagesLoadedOptions = {
      background: ".bg",
    };
    this.$el.imagesLoaded(options, this.setup.bind(this));
  }

  setup(): void {
    this.$el.isotope({
      itemSelector: ".off-portfolio-grid-cell",
      percentPosition: true,
      transitionDuration: "0.6s",
      getSortData: {
        category: "[data-category]",
      },
      sortBy: "category",
      masonry: {
        columnWidth: ".off-portfolio-sizer",
      },
      visibleStyle: {
        opacity: 1,
      },
      hiddenStyle: {
        opacity: 0,
      },
    });

    this.pageLazyLoad = new LazyLoad({
      container: document.querySelector(".off-portfolio-archive"),
    });
    this.pageLazyLoad.update();

    this.setColorFilter();
    this.setMisteryFilter();
    this.displayProject();
  }

  displayProject(): void {
    const parent = this;
    const $projectLinks: JQuery<HTMLElement> = $(
      ".off-portfolio-card .front a"
    );
    let $content: JQuery<HTMLElement>;

    $projectLinks.on("click", function (e: JQuery.ClickEvent) {
      e.preventDefault();

      const $wrapper = parent.$el.parents(".gs-content-wrapper");
      let $item: JQuery<HTMLElement> = $(".portfolio-item");

      if ($item.length !== 0) {
        $item.remove();
      }

      const href: string = $(e.target).attr("href");
      const $html: JQuery<HTMLElement> = $(
        '\
      <div class="portfolio-item"> \
        <div class="portfolio-wrapper"> \
          <div class="portfolio-cross"> \
            <button type="button"> \
              <img src="/wp-content/themes/off/assets/img/portfolio/cross.png"> \
            </button> \
          </div> \
          <div class="container"> \
            <div class="gs-portfolio-single-item large-pt large-pb"> \
            </div> \
          </div> \
        </div> \
      </div> \
      '
      );

      /*
      const jqxhr = $.ajax({
        url : href,
        type : 'GET',
        async: false
      });

      jqxhr.done(function(res) {

        $content = $(res).find('.off-portfolio-content');
        $wrapper.append($html);
        $('.gs-portfolio-single-item').append($content);
        parent.closeProject();

      });
      */

      let getPost = function (url): Promise<any> {
        return new Promise(function (resolve, reject) {
          let jqxhr = $.ajax({
            url: url,
            type: "GET",
            //async: false
          });
          resolve(
            jqxhr.done(function (res) {
              $content = $(res).find(".off-portfolio-content");
              $wrapper.append($html);
              $(".gs-portfolio-single-item").append($content);
              parent.closeProject();
            })
          );
          reject(jqxhr);
        });
      };

      getPost(href)
        .then(function () {
          $(".isotope-container").isotope();

          $(".gs-popup").magnificPopup({
            type: "image",
            delegate: ".gs-popup-link",
            tClose: "Fermer (Esc)",
            tLoading: "",
            gallery: {
              enabled: true,
              tPrev: "Précédent",
              tNext: "Suivant",
              tCounter: "%curr% / %total%",
            },
            mainClass: "mfp-zoom-in",
            removalDelay: 300,
            callbacks: {
              open: function () {
                $("html").css({
                  "margin-right": "initial",
                });
              },
              afterClose: function () {
                $("html").css({
                  overflow: "hidden",
                });
              },
            },
          });

          $(
            ".gs-portfolio-content-sticky .gs-portfolio-content-outer"
          ).theiaStickySidebar({
            additionalMarginTop: 50,
          });

          $("html").css("overflow", "hidden");
        })
        .catch(function () {
          console.log("L'url du projet n'existe pas");
        });
    });
  }

  closeProject(): void {
    let $close: JQuery<HTMLButtonElement> = $(".portfolio-cross button");
    $close.on("click", function (e: JQuery.ClickEvent) {
      e.preventDefault();
      const $this: JQuery<HTMLElement> = $(this);
      const $item: JQuery<HTMLElement> = $this.parents(".portfolio-item");
      $("html").css("overflow", "scroll");
      $item.remove();
    });
  }

  setColorFilter(): void {
    const $btns: JQuery<HTMLLinkElement> = $(".color-bar");
    $btns.on("click", (event: JQuery.ClickEvent): void => {
      event.preventDefault();
      const $target = $(event.target);
      if ($target.is(".is-checked")) {
        this.color = "";
      } else {
        this.color = $target.attr("data-filter");
        $target.parent().find(".is-checked").removeClass("is-checked");
      }
      $target.toggleClass("is-checked");
      this.filter();
    });
  }

  setMisteryFilter(): void {
    const $misterySlider = $("#flat-slider");

    $misterySlider
      .slider({
        max: 3,
        min: 1,
      })
      .slider("pips", {
        rest: "label",
        labels: ["Littérature", "Beaux-livres", "Design"],
      });

    let all: boolean = false;
    $misterySlider.on("slidechange", () => {
      let value = $misterySlider.slider("value");
      if (this.mistery == value) {
        if (1 == value) {
          this.mistery = undefined;
        } else {
          all = true;
          $misterySlider.slider("option", "value", 0);
          this.mistery = undefined;
        }
      } else if (all !== true) {
        this.mistery = value;
      } else {
        return;
      }
      this.filter();
      all = false;
    });
  }

  filter(): void {
    let cssClasses: Array<string> = [];

    let $item: JQuery<HTMLElement> = $(".portfolio-item");

    if ($item.length !== 0) {
      $item.remove();
    }

    if (this.mistery) {
      if (this.color) {
        cssClasses.push(`.${this.color}.cat-${this.mistery}`);
      } else {
        cssClasses.push(`.cat-${this.mistery}`);
      }
    } else if (this.color) {
      cssClasses.push(`.${this.color}`);
    } else {
      cssClasses.push("*");
    }
    const filterKey = cssClasses.join(", ");
    console.log({
      color: this.color,
      mistery: this.mistery,
      filter: filterKey,
    });
    this.$el.isotope({
      filter: filterKey,
    });
  }
}
